import { Link, linkOptions } from "@tanstack/react-router"

import { FormProofPills } from "@/components/account/layout/FormProofPills"
import { SignupForm } from "@/components/account/SignupForm"

export function SignupFormContent({
  onSuccess,
  slug,
}: {
  onSuccess: (email: string) => void
  slug?: string
}) {
  const toLoginOptions = slug
    ? linkOptions({ to: "/p/$slug/login", params: { slug } })
    : linkOptions({ to: "/login" })

  return (
    <>
      <h2 className="text-[26px] font-bold text-neutral-800 lg:text-4xl">
        Create account
      </h2>
      {/* Mobile carries this cross-link in the header instead, where the
          design puts it, so the proof pills can sit right under the heading. */}
      <p className="mb-4 hidden w-full text-lg text-neutral-500 lg:block">
        Already have an account?{" "}
        <Link className="underline" {...toLoginOptions}>
          Log in
        </Link>
      </p>

      <FormProofPills />

      <SignupForm onSuccess={onSuccess} slug={slug} />
    </>
  )
}
